// import { useTranslation } from 'react-i18next'
import { useInfiniteQuery, useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

import { addToast } from 'components/Toast/Toast'
import { getStoryLikesUsersList, uploadStory } from 'services/endpoints/story'
import { useUserProfile } from 'store'
import { type NewStory } from 'types/api/story'
import { type SortDirection } from 'types/enums'

export const useUploadStoryMutation = () => {
  const userData = useUserProfile()
  // const queryClient = useQueryClient()
  const navigate = useNavigate()
  // const { t } = useTranslation()

  return useMutation({
    mutationFn: async (newStory: NewStory) => await uploadStory(newStory),
    onSuccess: () => {
      navigate(`/${userData?.username}`, {
        state: { suppressFeedInitialFetch: true }
      })
    },
    onError: () => {
      addToast('error', 'There was an error')
    }
  })
}


export const useGetViewLikesStoryUsers = (
    storyId: string,
    sortDirection: SortDirection,
    searchTerm: string
) => {
    return useInfiniteQuery(
        ['viewerLikesStory', storyId, sortDirection, searchTerm],
        async ({ pageParam = 1 }) => {
            return await getStoryLikesUsersList(
                storyId,
                sortDirection,
                pageParam,
                searchTerm
            )
        },
        {
            getNextPageParam: lastPage => {
                if (
                    lastPage?.data?.pagination?.current_page *
                        lastPage?.data?.pagination?.per_page <
                    lastPage?.data?.pagination?.total
                ) {
                    return lastPage?.data?.pagination?.current_page + 1
                }
                return false
            },
            refetchOnWindowFocus: false,
            staleTime: 10000
        }
    )
}